import { render } from "./PanelRight.vue?vue&type=template&id=632e7576&scoped=true&ts=true"
import script from "./PanelRight.vue?vue&type=script&lang=ts"
export * from "./PanelRight.vue?vue&type=script&lang=ts"

import "./PanelRight.vue?vue&type=style&index=0&id=632e7576&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632e7576"]])

export default __exports__